export const operationalReportingMenuName = 'Menu::MenuG:OperatingReporting';
export const etsOperationalReportingMenuName = 'Menu::MenuG:OperationalReportingSettlements';
export const etsEnergySettlementMenuName = 'Menu::MenuG:EnergySettlements';
export const etsFinancialSettlementMenuName = 'Menu::MenuG:FinancialSettlements';
export const manageTariffSettlementsESetMenuName = 'Menu::MenuG:ManageSettlementsESet';
export const manageTariffSettlementsFSetMenuName = 'Menu::MenuG:ManageSettlementsFSet';
export const manageDlcSettlementsESetMenuName = 'Menu::MenuG:ManageDlcSettlementsESet';
export const manageDlcSettlementsFSetMenuName = 'Menu::MenuG:ManageDlcSettlementsFSet';
export const settlementsMenuName = 'Menu::MenuG:Settlements';
export const sappMarketSettlementResultsMenuName = 'Menu::MenuG:SettlementResults';
export const settlementsDashboardMenuName = 'Menu::MenuG:SettlementDashboardFSet';
